import { createReducer } from "@reduxjs/toolkit";   
import { fetchOpprtunity, getDocNumbyOpprId, GetLostDoc, getSQItems } from "./OpprThunk";

const handleAsyncActions = (builder, action, dataKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[dataKey] = true;
            state[dataKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[dataKey] = true;
            state[dataKey] = action.payload;            
            state.error[errorKey] = null;
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[dataKey] = true;
            state.error[errorKey] = action.payload;
        })
};

const initialState = {
    GetLostDocData: null,
    GetOpportHistory:null,
    SQItemsByDocEntry:null,
    listOfOpporID:null,

    loading: {
        GetLostDocData: false,
        GetOpportHistory:false,
        SQItemsByDocEntry:false,
        listOfOpporID:false,
    },

    error: {
        GetLostDocError: null,
        GetOpportHistoryError:null,
        SQItemsByDocEntryError:null,
        listOfOpporIDError:null,

    },
};

export const OpprReducer = createReducer(initialState, (bulider) => {
    handleAsyncActions(bulider, GetLostDoc, "GetLostDocData","GetLostDocError");
    handleAsyncActions(bulider, fetchOpprtunity, "GetOpportHistory","GetOpportHistoryError");
    handleAsyncActions(bulider, getSQItems, "SQItemsByDocEntry","SQItemsByDocEntryError");
    handleAsyncActions(bulider, getDocNumbyOpprId, "listOfOpporID","listOfOpporIDError");
});

export default OpprReducer;